<div class="child-container" [formGroup]="schedulerSetHoursForm">
	<div class="group-gap row mb-2">
    <div class="col-md-3">
      <label class="resource-name-label" for="resourceName">WORKING HOURS:</label>
    </div>
    <mat-radio-group aria-label="Select an option" class="col-md-8" formControlName="hours">
      <div class="col-md-4">
        <mat-radio-button [value]="1">USE STANDARD WORKSHOP HOURS </mat-radio-button>
      </div>
      <div class="col-md-4"><mat-radio-button [value]="2">USE CUSTOM WORKSHOP HOURS</mat-radio-button></div>
    </mat-radio-group>
    <div *ngIf="showHoursForm">
      <div *ngIf="showHoursForm && this.schedulerSetHoursForm.value.hours === 2">Need at least Day Start and Finish time</div>
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-2">
          <mat-label>DAY START TIME</mat-label
          ><input
            matInput
            type="time"
            [readonly]="!overriddenHoursTF"
            [class.inputDisable]="!overriddenHoursTF"
            formControlName="startTime"
          />
        </div>
        <div class="col-md-2">
          <mat-label>DAY END TIME</mat-label
          ><input
            matInput
            type="time"
            [readonly]="!overriddenHoursfinishTimeTF || !overriddenHoursTF"
            [class.inputDisable]="!overriddenHoursfinishTimeTF || !overriddenHoursTF"
            formControlName="finishTime"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-2 bg-light">
          <mat-label>BREAK 1 START</mat-label
          ><input
            matInput
            type="time"
            [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
            [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
            formControlName="break1StartTime"
          />
        </div>
        <div class="col-md-2 bg-light">
          <mat-label>BREAK 1 END</mat-label
          ><input
            matInput
            type="time"
            [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
            [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
            formControlName="break1EndTime"
          />
        </div>
        <div class="col-md-2 bg-light">
          <div><mat-label>BREAK 1 NAME</mat-label></div>
          <div>
            <input
              matInput
              [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
              [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
              formControlName="break1Name"
            />
          </div>
        </div>
        <div
          *ngIf="
            overriddenHoursTF &&
            (this.schedulerSetHoursForm.value.break1StartTime || this.schedulerSetHoursForm.value.break1EndTime || this.schedulerSetHoursForm.value.break1Name)
          "
          class="col-md-2"
        >
          <mat-icon (click)="clearBreakValue(1)" title="Clear">close</mat-icon>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3"></div>

        <div class="col-md-2">
          <mat-label>BREAK 2 START</mat-label
          ><input
            matInput
            type="time"
            [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
            [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
            formControlName="break2StartTime"
          />
        </div>
        <div class="col-md-2">
          <mat-label>BREAK 2 END</mat-label
          ><input
            matInput
            type="time"
            [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
            [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
            formControlName="break2EndTime"
          />
        </div>
        <div class="col-md-2">
          <mat-label>BREAK 2 NAME</mat-label
          ><input
            matInput
            [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
            [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
            formControlName="break2Name"
          />
        </div>
        <div
          *ngIf="
            overriddenHoursTF &&
            (this.schedulerSetHoursForm.value.break2StartTime || this.schedulerSetHoursForm.value.break2EndTime || this.schedulerSetHoursForm.value.break2Name)
          "
          class="col-md-2"
        >
          <mat-icon (click)="clearBreakValue(2)" title="Clear">close</mat-icon>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3"></div>

        <div class="col-md-2 bg-light">
          <mat-label>BREAK 3 START</mat-label
          ><input
            matInput
            type="time"
            [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
            [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
            formControlName="break3StartTime"
          />
        </div>
        <div class="col-md-2 bg-light">
          <mat-label>BREAK 3 END</mat-label
          ><input
            matInput
            type="time"
            [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
            [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
            formControlName="break3EndTime"
          />
        </div>
        <div class="col-md-2 bg-light">
          <mat-label>BREAK 3 NAME</mat-label
          ><input
            matInput
            [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
            [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
            formControlName="break3Name"
          />
        </div>
        <div
          *ngIf="
            overriddenHoursTF &&
            (this.schedulerSetHoursForm.value.break3StartTime || this.schedulerSetHoursForm.value.break3EndTime || this.schedulerSetHoursForm.value.break3Name)
          "
          class="col-md-2"
        >
          <mat-icon (click)="clearBreakValue(3)" title="Clear">close</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>